import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/producto/importer/productoImporterActions';

export default importerReducers(actions);
